import { ContactCompanySearchResult } from 'models/companies'
import { TYPE_MAPPING } from '../constants'

/**
 * Transform First Bite results to match ContactCompanySearchResult format
 */
export function transformFirstBiteResults(
  results: any[]
): ContactCompanySearchResult[] {
  const typeToCategoryMapping: Record<string, string> = {
    RE: 'Commercial',
    LG: 'Commercial',
    CS: 'Retail',
    HO: 'Non-Commercial',
    NH: 'Non-Commercial',
    DI: 'Non-Commercial',
    CU: 'Non-Commercial',
  }

  return results.map((result) => ({
    contact_company_id: parseInt(result.item_id),
    name: result.name,
    domain: result.domain,
    size: result.count,
    category_name: typeToCategoryMapping[result.type] || 'Other',
    sub_category_name: TYPE_MAPPING[result.type] || result.type,
    city: '',
    state: '',
    zipcode: '',
    country: '',
    category: 1,
    sub_category: 1,
    created_date: new Date().toISOString(),
    score: result.score,
    type: result.type, // Preserve original 2-letter code
    city_summary: result.city_summary || '',
    state_summary: result.state_summary || '',
  }))
}

/**
 * Sort search results based on sort option
 */
export function sortSearchResults(
  results: ContactCompanySearchResult[],
  sortBy: string
): ContactCompanySearchResult[] {
  if (sortBy === 'relevance') return results

  return [...results].sort((a, b) => {
    switch (sortBy) {
      case 'alphabetical_asc':
      case 'alphabetical':
        return a.name.localeCompare(b.name)
      case 'alphabetical_desc':
        return b.name.localeCompare(a.name)
      case 'size_desc':
      case 'size':
        return (b.size || 0) - (a.size || 0)
      case 'size_asc':
        return (a.size || 0) - (b.size || 0)
      default:
        return 0
    }
  })
}

/**
 * Check if search term is valid for performing search
 */
export function isValidSearchTerm(searchTerm: string): boolean {
  return searchTerm.trim().length >= 2
}
